import React, { useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { Hero } from '../../configs';
import { ENV } from '../../constants';
import { useWindowSize } from '../../utils/hooks';
import { clsx } from '../../utils/utils';
import Button from '../Button';
import Caption from '../Caption';
import Layout from '../Layout';
import Panel from '../Panel';
import SketchPanel from '../SketchPanel';

import * as styles from './QuestionScreen.module.scss';

export interface QuestionScreenProps {
  sketchImage: any;
  onSketchClick?: () => void;
  currentQuestionNumber: number;
  totalQuestionsNumber: number;
  question: string;
  answersWithKeys: Array<[Hero, string]>;
  onAnswerPick: (answerKey: Hero) => void;
}

const QuestionScreen = ({
  sketchImage,
  onSketchClick,
  currentQuestionNumber,
  totalQuestionsNumber,
  question,
  answersWithKeys,
  onAnswerPick,
}: QuestionScreenProps): React.ReactElement => {
  const windowSize = useWindowSize();
  const [selectedAnswerKey, setSelectedAnswerKey] = useState<Hero | null>(null);
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          {windowSize && windowSize.width >= 1200 && (
            <SketchPanel
              className={styles.sketchPanel}
              sketchImage={sketchImage}
              onClick={onSketchClick}
            ></SketchPanel>
          )}
          <Panel className={styles.questionPanel}>
            <Caption className={styles.caption}>
              Question {currentQuestionNumber} of {totalQuestionsNumber}
            </Caption>
            <p className={styles.question}>{question}</p>
            <div className={styles.answersContainer}>
              {answersWithKeys.map(([answerKey, answer]) => (
                <Button
                  pressed={selectedAnswerKey === answerKey}
                  disabled={!!selectedAnswerKey}
                  key={currentQuestionNumber + '-' + answerKey}
                  smallFont
                  className={clsx(
                    styles.answer,
                    selectedAnswerKey === answerKey && styles.selectedAnswer,
                  )}
                  onClick={() => {
                    setSelectedAnswerKey(answerKey);
                    setTimeout(
                      () => {
                        unstable_batchedUpdates(() => {
                          onAnswerPick(answerKey);
                          setSelectedAnswerKey(null);
                        });
                      },
                      ENV === 'development' ? 0 : 300,
                    );
                  }}
                >
                  {answer}
                </Button>
              ))}
            </div>
          </Panel>
        </div>
      </div>
    </Layout>
  );
};

export default QuestionScreen;
